import { render } from "./PsErrorDialog.vue?vue&type=template&id=a657aedc&ts=true"
import script from "./PsErrorDialog.vue?vue&type=script&lang=ts"
export * from "./PsErrorDialog.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__